import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Supprimer — corbeille duotone */
export const TrashIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Contenu menthe */}
      <path d="M6 8.5h12V19a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8.5z" fill="var(--equiply-icon-bg)" fillOpacity="0.55" />
      {/* Contour corbeille */}
      <path d="M5 8.5h14M9 8.5V5.5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 5.5v3M6.5 8.5V19a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V8.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      {/* Rainures */}
      <path d="M10 12.5v5M14 12.5v5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
TrashIcon.displayName = "TrashIcon";
